import { all } from "redux-saga/effects";

export default function* workInternalCultureSaga() {
  yield all([]);
}
